export const logException = (e: unknown): void => {
    if (process.env.REACT_APP_ENV !== "production") {
        /* eslint-disable no-console */
        console.error(e);
    }
};
